
import TripDetail from '@components/trip-detail/trip-detail/TripDetail.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { scrollIntoPage } from '@util/scrollUtils';

@Component({
  name: "TripEdit",
  components: {
    TripDetail
  }
})
export default class TripEdit extends Vue {
  get tripId() {
    return parseInt(this.$route.params.id);
  }

  get editMode() {
    return this.$route.query.editMode === 'true';
  }

  get pilotId() {
    return parseInt(this.$route.query.pilotId as string);
  }

  get tagId() {
    return parseInt(this.$route.query.tagId as string);
  }

  private async switchEditMode(edit: boolean) {
    const query = edit ? { editMode: 'true' } : {};
    await this.$router.replace({ query });

    if (!edit) {
      scrollIntoPage();
    }
  }
}
